module.exports = __webpack_public_path__ + "media/site_templates/www.localhomebuilders.net.au/images/feature_1-45708aac62941dc3ce7fc34b0facb6b9.jpeg";